export default __webpack_public_path__ + "static/media/office.773d114d.svg";